import { PureComponent } from 'react';
import { Link, Switch, Route, withRouter, Redirect } from 'react-router-dom';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import { getMeta } from 'constants/meta';
import Icon from 'components/Icon';
import ScrollWrapper from 'components/ScrollWrapper';
import Head from 'components/Head';

import {
  LoginForm,
  RecoveryForm,
  SuccessForm,
  NewPasswordForm,
} from './components';
import { MODAL_BODY_CLASS, PATHS_TO_BLOCK_DIRECT_CONNECT } from './constants';

class Login extends PureComponent {
  componentDidMount() {
    document.body.classList.add(MODAL_BODY_CLASS);
    document.addEventListener('keydown', this.handleEscapeKeyPress);

    window.addEventListener('orientationchange', this.handleOrientationChange);
  }

  componentWillUnmount() {
    document.body.classList.remove(MODAL_BODY_CLASS);
    document.removeEventListener('keydown', this.handleEscapeKeyPress);
    window.removeEventListener(
      'orientationchange',
      this.handleOrientationChange
    );
  }

  // This is here because ios browser won't initialize scroll on orientation change if scroll wasn't present before change occurred
  handleOrientationChange = () => {
    const originalBodyStyle = getComputedStyle(document.body).getPropertyValue(
      'display'
    );

    document.body.style.display = 'none';

    setTimeout(() => (document.body.style.display = originalBodyStyle), 100);
  };

  closeModal = () => {
    const { parentPath, history } = this.props;
    history.push(parentPath, this.props.location.state);
  };

  handleEscapeKeyPress = e => {
    if (e.keyCode === 27) {
      this.closeModal();
    }
  };

  render() {
    const { location } = this.props;
    const { title, description } = getMeta(location.pathname);

    if (PATHS_TO_BLOCK_DIRECT_CONNECT.includes(location.pathname)) {
      return <Redirect to="/login" />;
    }

    return (
      <div className="overlay">
        <Head title={title} description={description} />
        <ScrollWrapper type="thin" viewClassName="webkit-scroll-container">
          <div className="overlay__btn-close" onClick={this.closeModal}>
            <Icon icon="close-20" />
          </div>
          <div className="login">
            <div className="login__wrapper">
              <div className="login__logo _mb-101 _mb-note-36">
                <Link to="/" className="login__logo-link">
                  <Icon icon="logo-no-text" />
                </Link>
              </div>
              <TransitionGroup className="_relative">
                <CSSTransition
                  key={location.key}
                  classNames="opacity"
                  timeout={300}
                >
                  <div>
                    <Switch location={location}>
                      <Route path="/login" exact component={LoginForm} />
                      <Route path="/login/recovery" component={RecoveryForm} />
                      <Route path="/login/success" component={SuccessForm} />
                      <Route
                        path="/password-reset"
                        component={NewPasswordForm}
                      />
                    </Switch>
                  </div>
                </CSSTransition>
              </TransitionGroup>
            </div>
          </div>
        </ScrollWrapper>
      </div>
    );
  }
}

export default withRouter(Login);
